import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { FormInput } from "../../wrappers/formInput";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw} from 'draft-js';
import { DropDownInput } from '../../wrappers/selectInput';
import Button from '../../components/button';
import FormHead from '../../components/headings/FromHead';
import { Icon } from '@iconify/react';
import Styles from './styles.module.scss';
import ProfilePicture from '../../modal/profilePicture';
import {checkSize} from '../../utils/EllowUtils';
import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import mixpanelData from '../../utils/mixpanel';

const { v4: uuidv4 } = require('uuid');


export type profile = {
  profileUrl: string;
  linkedinId: string;
  description: string;
  roleDescription: string;
  website: string;
  size: any;
  currencyType: any;
  workWithRemote: number;
}

interface Props {
  defaultValues?: any;
  clickHandler?: any;
  locationChange?: any;
  defImage?: string;
  disable?: boolean;
}

const Profile: React.FC<Props> = ({ defaultValues , clickHandler, locationChange, defImage, disable }) => {
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  )

  const validationSchema = Yup.object({
    // roleDescription: Yup.string().required("Field is required"),
    website: Yup.string().required("Field is required"),
    size: Yup.object().required("Field is required"),
  })

  const [modal , setModal] = useState<boolean>()
  const [image, setImage] = useState<any>()
  const [companyName, setCompanyName] = useState<string>('')

  const [address, setAddress] = useState('')
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])

 
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  }

  useEffect(() => {
    if (defaultValues && defaultValues.customer_metadata) {
      reset(defaultValues.customer_metadata)
      setValue('size', checkSize(defaultValues.customer_metadata.size))
      setCompanyName(defaultValues.customer_metadata.companyName)
      const contentState = editorState.getCurrentContent();
      setLocationArray(defaultValues.customer_metadata.googleLocations)
      if (JSON.stringify(convertToRaw(contentState)) !== defaultValues.customer_metadata.aboutCompany) {
        try {
          setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValues.customer_metadata.aboutCompany)))); 
        }
        catch (e) {
        }
      }
    }  
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues])

  
  useEffect(() => {
    setImage(defImage)
  }, [defImage])
  
  
  const { register, handleSubmit, control, reset, setValue, formState } =
    useForm<profile>(formOptions);

  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    setValue("description", JSON.stringify(convertToRaw(contentState)));
  }

  const onSubmit = (data: any) => {
    data.image = image;
    data.googleLocations = locationArray
    clickHandler(data)
  }

  const uploadPicture = () => {
    setModal(true)
  }

  const onClose = () => {
    setModal(false)
  }


  const handleSelect = async (value: any) => {

    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
  }

  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  return (
    <section>
       <figure className={Styles.uploadPicWrap}>
        {image ? <img alt='' src={image} /> :
          <span className={Styles.noPicWrap}>{companyName[0]}{companyName[1]}</span>
          }
          <span className={Styles.uploadPic}>
            <button onClick={uploadPicture}><Icon icon="ant-design:camera-outlined" /></button>
          </span>
      </figure>
      <form>
        <div className="form-group">
          <FormHead>Basic Information</FormHead>
          <FormInput<profile>
            id="profileUrl"
            type="email"
            name="profileUrl"
            label="URL for ellow.io profile"
            placeholder="ellow.io/in/profiles"
            register={register}
            errors={formState.errors}
          />
        </div>
        <div className="form-group">
          <label className="lablel"><Icon icon="jam:linkedin-square" />LinkedIn  URL</label>
          <FormInput<profile>
            id="linkedinId"
            type="text"
            name="linkedinId"
            label=""
            placeholder="www.linkedin.com/in/yourusername"
            register={register}
            errors={formState.errors}
          />
        </div>
        <div className="form-group">
          <label className="lablel">About the company</label>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={onEditorStateChange}
          />
        </div>
        <div className="half-form-wrap">
          {/* <div className="form-group">
            <label className="lablel">What role describes you*</label>
            <DropDownInput<profile>
              name="roleDescription"
              label=""
              data={['Recruiter','Hirer', 'Provider']}
              register={register}
              errors={formState.errors}
              control={control}
            />
          </div> */}
          <div className="form-group">
            <label className="lablel">Company Website*</label>
            <FormInput<profile>
              id="website"
              type="text"
              name="website"
              placeholder="www.yourcompany.com"
              register={register}
              errors={formState.errors}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Company size*</label>
            <DropDownInput<profile>
              name="size"
              label=""
              data={[{ id: 0, name: '0-10' }, { id: 1, name: '11-50' }, { id: 2, name: '51-100' },  { id: 3, name: '251-10k' }, { id: 4, name: '10k+' }]}
              register={register}
              errors={formState.errors}
              control={control}
              dataItemKey='id'
              textField='name'
            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Preferred Currency</label>
            <DropDownInput<profile>
              name="currencyType"
              register={register}
              errors={formState.errors}
              data={['INR','USD']}
              control={control}
            />
          </div>
        </div>
        <div className={Styles.subHeadWrap}>
          <FormHead>Location</FormHead>
        </div>
        <div className='preference-form-wrapper'>
           <div className="form-group">
                { <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
        <ul className={Styles.addressList}>
          {locationArray && locationArray.map((item: any) => {
              return (
                < li >
                <Icon icon="ep:location" className={Styles.location} />
                <div className={Styles.addressLine}>
                    <div>
                      {item.name}
                    </div>
                    <div className={Styles.addressAction}>
                      <Icon icon="icon-park-outline:delete" onClick={() => removeLocation(item)}/>
                    </div>
                </div>
              </li>
             )
            })
          }
      </ul>
        <div className="action-form">
          <Button onClick={[]} variant="cancel">
            Back
          </Button>
          <Button disabled={disable} onClick={handleSubmit(onSubmit)} variant="primary">
            Save
          </Button>
        </div>
      </form>
      {modal && <ProfilePicture onClose={onClose} submitImage={(image: any) => { setImage(image); setModal(false) }} defImage={image} companyName={companyName} />}
    </section>
  )
}

export default Profile;
